export default __webpack_public_path__ + "static/auto-layout-do-light-25cc3322e7a215e0700d55531fc950983b93280e77f84145e264e521210b2a87.png";